import Kn from "../../@babel/runtime/helpers/esm/typeof.mjs";
import Re from "../../@babel/runtime/helpers/esm/extends.mjs";
import d from "../../@babel/runtime/helpers/esm/defineProperty.mjs";
import Fn from "../../@babel/runtime/helpers/esm/toConsumableArray.mjs";
import S from "../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import X from "../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import Bn from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import Ie from "../../classnames/index.mjs";
import Pe from "../../rc-util/es/hooks/useLayoutEffect.mjs";
import Wn from "../../rc-util/es/hooks/useMergedState.mjs";
import kn from "../../rc-util/es/isMobile.mjs";
import Ae from "../../rc-util/es/KeyCode.mjs";
import { useComposeRef as zn } from "../../rc-util/es/ref.mjs";
import * as t from "react";
import { BaseSelectContext as Ln } from "./hooks/useBaseProps.mjs";
import Un from "./hooks/useDelayReset.mjs";
import jn from "./hooks/useLock.mjs";
import qn from "./hooks/useSelectTriggerControl.mjs";
import Hn from "./Selector/index.mjs";
import Jn from "./SelectTrigger.mjs";
import Me from "./TransBtn.mjs";
import { getSeparatedContent as Qn } from "./utils/valueUtil.mjs";
var Xn = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "showArrow", "inputIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], Yn = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"];
function _n(e) {
  return e === "tags" || e === "multiple";
}
var Gn = /* @__PURE__ */ t.forwardRef(function(e, Oe) {
  var A, s, M = e.id, l = e.prefixCls, Te = e.className, Y = e.showSearch, Ke = e.tagRender, Fe = e.direction, _ = e.omitDomProps, f = e.displayValues, O = e.onDisplayValuesChange, G = e.emptyOptions, Z = e.notFoundContent, T = Z === void 0 ? "Not Found" : Z, $ = e.onClear, u = e.mode, p = e.disabled, P = e.loading, ee = e.getInputElement, ne = e.getRawInputElement, Be = e.open, We = e.defaultOpen, K = e.onDropdownVisibleChange, ke = e.activeValue, oe = e.onActiveValueChange, ze = e.activeDescendantId, te = e.searchValue, Le = e.autoClearSearchValue, V = e.onSearch, re = e.onSearchSplit, F = e.tokenSeparators, ae = e.allowClear, le = e.showArrow, Ue = e.inputIcon, je = e.clearIcon, qe = e.OptionList, He = e.animation, Je = e.transitionName, Qe = e.dropdownStyle, Xe = e.dropdownClassName, Ye = e.dropdownMatchSelectWidth, _e = e.dropdownRender, Ge = e.dropdownAlign, Ze = e.placement, $e = e.builtinPlacements, en = e.getPopupContainer, ie = e.showAction, nn = ie === void 0 ? [] : ie, ue = e.onFocus, ce = e.onBlur, se = e.onKeyUp, pe = e.onKeyDown, me = e.onMouseDown, on = Bn(e, Xn), g = _n(u), D = (Y !== void 0 ? Y : g) || u === "combobox", B = X({}, on);
  Yn.forEach(function(n) {
    delete B[n];
  }), _ == null || _.forEach(function(n) {
    delete B[n];
  });
  var tn = t.useState(!1), de = S(tn, 2), rn = de[0], an = de[1];
  t.useEffect(function() {
    an(kn());
  }, []);
  var W = t.useRef(null), k = t.useRef(null), z = t.useRef(null), R = t.useRef(null), E = t.useRef(null), ln = Un(), L = S(ln, 3), U = L[0], j = L[1], un = L[2];
  t.useImperativeHandle(Oe, function() {
    var n, o;
    return {
      focus: (n = R.current) === null || n === void 0 ? void 0 : n.focus,
      blur: (o = R.current) === null || o === void 0 ? void 0 : o.blur,
      scrollTo: function(i) {
        var r;
        return (r = E.current) === null || r === void 0 ? void 0 : r.scrollTo(i);
      }
    };
  });
  var v = t.useMemo(function() {
    var n;
    if (u !== "combobox")
      return te;
    var o = (n = f[0]) === null || n === void 0 ? void 0 : n.value;
    return typeof o == "string" || typeof o == "number" ? String(o) : "";
  }, [te, u, f]), fe = u === "combobox" && typeof ee == "function" && ee() || null, b = typeof ne == "function" && ne(), cn = zn(k, b == null || (A = b.props) === null || A === void 0 ? void 0 : A.ref), sn = t.useState(!1), ve = S(sn, 2), pn = ve[0], mn = ve[1];
  Pe(function() {
    mn(!0);
  }, []);
  var dn = Wn(!1, {
    defaultValue: We,
    value: Be
  }), he = S(dn, 2), ge = he[0], q = he[1], a = pn ? ge : !1, we = !T && G;
  (p || we && a && u === "combobox") && (a = !1);
  var C = we ? !1 : a, h = t.useCallback(function(n) {
    var o = n !== void 0 ? n : !a;
    p || (q(o), a !== o && (K == null || K(o)));
  }, [p, a, q, K]), fn = t.useMemo(function() {
    return (F || []).some(function(n) {
      return [`
`, `\r
`].includes(n);
    });
  }, [F]), H = function(n, o, i) {
    var r = !0, c = n;
    oe == null || oe(null);
    var m = i ? null : Qn(n, F);
    return u !== "combobox" && m && (c = "", re == null || re(m), h(!1), r = !1), V && v !== c && V(c, {
      source: o ? "typing" : "effect"
    }), r;
  }, vn = function(n) {
    !n || !n.trim() || V(n, {
      source: "submit"
    });
  };
  t.useEffect(function() {
    !a && !g && u !== "combobox" && H("", !1, !1);
  }, [a]), t.useEffect(function() {
    ge && p && q(!1), p && j(!1);
  }, [p]);
  var hn = jn(), ye = S(hn, 2), gn = ye[0], wn = ye[1], yn = function(n) {
    var o = gn(), i = n.which;
    if (i === Ae.ENTER && (u !== "combobox" && n.preventDefault(), a || h(!0)), wn(!!v), i === Ae.BACKSPACE && !o && g && !v && f.length) {
      for (var r = Fn(f), c = null, m = r.length - 1; m >= 0; m -= 1) {
        var I = r[m];
        if (!I.disabled) {
          r.splice(m, 1), c = I;
          break;
        }
      }
      c && O(r, {
        type: "remove",
        values: [c]
      });
    }
    for (var w = arguments.length, x = new Array(w > 1 ? w - 1 : 0), y = 1; y < w; y++)
      x[y - 1] = arguments[y];
    if (a && E.current) {
      var De;
      (De = E.current).onKeyDown.apply(De, [n].concat(x));
    }
    pe == null || pe.apply(void 0, [n].concat(x));
  }, bn = function(n) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), r = 1; r < o; r++)
      i[r - 1] = arguments[r];
    if (a && E.current) {
      var c;
      (c = E.current).onKeyUp.apply(c, [n].concat(i));
    }
    se == null || se.apply(void 0, [n].concat(i));
  }, Sn = function(n) {
    var o = f.filter(function(i) {
      return i !== n;
    });
    O(o, {
      type: "remove",
      values: [n]
    });
  }, J = t.useRef(!1), En = function() {
    j(!0), p || (ue && !J.current && ue.apply(void 0, arguments), nn.includes("focus") && h(!0)), J.current = !0;
  }, Cn = function() {
    j(!1, function() {
      J.current = !1, h(!1);
    }), !p && (v && (u === "tags" ? V(v, {
      source: "submit"
    }) : u === "multiple" && V("", {
      source: "blur"
    })), ce && ce.apply(void 0, arguments));
  }, N = [];
  t.useEffect(function() {
    return function() {
      N.forEach(function(n) {
        return clearTimeout(n);
      }), N.splice(0, N.length);
    };
  }, []);
  var Nn = function(n) {
    var o, i = n.target, r = (o = z.current) === null || o === void 0 ? void 0 : o.getPopupElement();
    if (r && r.contains(i)) {
      var c = setTimeout(function() {
        var x = N.indexOf(c);
        if (x !== -1 && N.splice(x, 1), un(), !rn && !r.contains(document.activeElement)) {
          var y;
          (y = R.current) === null || y === void 0 || y.focus();
        }
      });
      N.push(c);
    }
    for (var m = arguments.length, I = new Array(m > 1 ? m - 1 : 0), w = 1; w < m; w++)
      I[w - 1] = arguments[w];
    me == null || me.apply(void 0, [n].concat(I));
  }, xn = t.useState(null), be = S(xn, 2), Se = be[0], Vn = be[1], Dn = t.useState({}), Rn = S(Dn, 2), In = Rn[1];
  function Pn() {
    In({});
  }
  Pe(function() {
    if (C) {
      var n, o = Math.ceil((n = W.current) === null || n === void 0 ? void 0 : n.offsetWidth);
      Se !== o && !Number.isNaN(o) && Vn(o);
    }
  }, [C]);
  var Ee;
  b && (Ee = function(n) {
    h(n);
  }), qn(function() {
    var n;
    return [W.current, (n = z.current) === null || n === void 0 ? void 0 : n.getPopupElement()];
  }, C, h, !!b);
  var An = t.useMemo(function() {
    return X(X({}, e), {}, {
      notFoundContent: T,
      open: a,
      triggerOpen: C,
      id: M,
      showSearch: D,
      multiple: g,
      toggleOpen: h
    });
  }, [e, T, C, a, M, D, g, h]), Ce = le !== void 0 ? le : P || !g && u !== "combobox", Ne;
  Ce && (Ne = /* @__PURE__ */ t.createElement(Me, {
    className: Ie("".concat(l, "-arrow"), d({}, "".concat(l, "-arrow-loading"), P)),
    customizeIcon: Ue,
    customizeIconProps: {
      loading: P,
      searchValue: v,
      open: a,
      focused: U,
      showSearch: D
    }
  }));
  var xe, Mn = function() {
    var n;
    $ == null || $(), (n = R.current) === null || n === void 0 || n.focus(), O([], {
      type: "clear",
      values: f
    }), H("", !1, !1);
  };
  !p && ae && (f.length || v) && !(u === "combobox" && v === "") && (xe = /* @__PURE__ */ t.createElement(Me, {
    className: "".concat(l, "-clear"),
    onMouseDown: Mn,
    customizeIcon: je
  }, "×"));
  var On = /* @__PURE__ */ t.createElement(qe, {
    ref: E
  }), Tn = Ie(l, Te, (s = {}, d(s, "".concat(l, "-focused"), U), d(s, "".concat(l, "-multiple"), g), d(s, "".concat(l, "-single"), !g), d(s, "".concat(l, "-allow-clear"), ae), d(s, "".concat(l, "-show-arrow"), Ce), d(s, "".concat(l, "-disabled"), p), d(s, "".concat(l, "-loading"), P), d(s, "".concat(l, "-open"), a), d(s, "".concat(l, "-customize-input"), fe), d(s, "".concat(l, "-show-search"), D), s)), Ve = /* @__PURE__ */ t.createElement(Jn, {
    ref: z,
    disabled: p,
    prefixCls: l,
    visible: C,
    popupElement: On,
    containerWidth: Se,
    animation: He,
    transitionName: Je,
    dropdownStyle: Qe,
    dropdownClassName: Xe,
    direction: Fe,
    dropdownMatchSelectWidth: Ye,
    dropdownRender: _e,
    dropdownAlign: Ge,
    placement: Ze,
    builtinPlacements: $e,
    getPopupContainer: en,
    empty: G,
    getTriggerDOMNode: function() {
      return k.current;
    },
    onPopupVisibleChange: Ee,
    onPopupMouseEnter: Pn
  }, b ? /* @__PURE__ */ t.cloneElement(b, {
    ref: cn
  }) : /* @__PURE__ */ t.createElement(Hn, Re({}, e, {
    domRef: k,
    prefixCls: l,
    inputElement: fe,
    ref: R,
    id: M,
    showSearch: D,
    autoClearSearchValue: Le,
    mode: u,
    activeDescendantId: ze,
    tagRender: Ke,
    values: f,
    open: a,
    onToggleOpen: h,
    activeValue: ke,
    searchValue: v,
    onSearch: H,
    onSearchSubmit: vn,
    onRemove: Sn,
    tokenWithEnter: fn
  }))), Q;
  return b ? Q = Ve : Q = /* @__PURE__ */ t.createElement("div", Re({
    className: Tn
  }, B, {
    ref: W,
    onMouseDown: Nn,
    onKeyDown: yn,
    onKeyUp: bn,
    onFocus: En,
    onBlur: Cn
  }), U && !a && /* @__PURE__ */ t.createElement("span", {
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    },
    "aria-live": "polite"
  }, "".concat(f.map(function(n) {
    var o = n.label, i = n.value;
    return ["number", "string"].includes(Kn(o)) ? o : i;
  }).join(", "))), Ve, Ne, xe), /* @__PURE__ */ t.createElement(Ln.Provider, {
    value: An
  }, Q);
});
process.env.NODE_ENV !== "production" && (Gn.displayName = "BaseSelect");
export {
  Gn as default,
  _n as isMultiple
};
//# sourceMappingURL=BaseSelect.mjs.map
